export enum EnTextTemplateTextType {
  SingleLine,
  PlainText,
  Html,
}
